/* Hoolest delivery strip — ZIP-first delivery estimate.
   Hosted as a Shopify theme asset and loaded with <script src>, so it executes
   even where inline scripts are blocked. Ships from Arizona; transit by ZIP zone.
   No network calls. Updated June 12, 2026. */
(function () {
  var CUTOFF_HOUR = 14, CUTOFF_MIN = 0;   // 2:00 PM order cutoff
  var HANDLING_DAYS = 2;                   // up to 48 business hours to ship
  var WORKDAYS = [1, 2, 3, 4, 5];          // Mon–Fri
  var HOLIDAYS = ["2026-01-01","2026-01-19","2026-02-16","2026-04-03","2026-05-25","2026-06-19","2026-07-03","2026-09-07","2026-10-12","2026-11-11","2026-11-26","2026-11-27","2026-12-25","2027-01-01"];
  var DEFAULT_WINDOW = { min: 3, max: 5 }; // shown before a ZIP is entered
  var ticker = null;

  function $(id) { return document.getElementById(id); }
  function lsGet(k) { try { return localStorage.getItem(k) || ''; } catch (e) { return ''; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  // Transit window from an Arizona origin, by ZIP first digit.
  function zoneFor(zip) {
    if (!/^\d{5}$/.test(zip)) return DEFAULT_WINDOW;
    var d = zip.charAt(0);
    if (d === '8' || d === '9') return { min: 2, max: 4 }; // Mountain / West
    if (d === '7') return { min: 3, max: 5 };              // South Central
    if (d === '5' || d === '6') return { min: 4, max: 5 }; // Midwest
    if (d === '3' || d === '4') return { min: 4, max: 6 }; // Southeast / Mid
    return { min: 5, max: 7 };                             // 0,1,2 Northeast
  }

  function iso(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  function isWorkday(d) { return WORKDAYS.indexOf(d.getDay()) !== -1 && HOLIDAYS.indexOf(iso(d)) === -1; }
  function addBusinessDays(start, n) { var d = new Date(start), added = 0; while (added < n) { d.setDate(d.getDate() + 1); if (isWorkday(d)) added++; } return d; }

  var MON = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  function fmt(d) { return MON[d.getMonth()] + ' ' + d.getDate(); }
  function fmtRange(a, b) { return a.getMonth() === b.getMonth() ? MON[a.getMonth()] + ' ' + a.getDate() + '\u2013' + b.getDate() : fmt(a) + ' \u2013 ' + fmt(b); }

  function render(win) {
    if (ticker) clearInterval(ticker);
    function tick() {
      var now = new Date(), cut = new Date(now); cut.setHours(CUTOFF_HOUR, CUTOFF_MIN, 0, 0);
      var past = now >= cut;
      var base = new Date(now);
      if (past || !isWorkday(base)) { base.setDate(base.getDate() + 1); while (!isWorkday(base)) base.setDate(base.getDate() + 1); }
      var ship = addBusinessDays(base, HANDLING_DAYS);
      var dMin = addBusinessDays(ship, win.min), dMax = addBusinessDays(ship, win.max);
      if ($('hps-order-date')) $('hps-order-date').textContent = 'Today';
      if ($('hps-ship-date')) $('hps-ship-date').textContent = fmt(ship);
      if ($('hps-cutoff-ship')) $('hps-cutoff-ship').textContent = fmt(ship);
      if ($('hps-deliver-date')) $('hps-deliver-date').textContent = fmtRange(dMin, dMax);
      var nc = new Date(cut);
      if (past) { nc.setDate(nc.getDate() + 1); while (!isWorkday(nc)) nc.setDate(nc.getDate() + 1); nc.setHours(CUTOFF_HOUR, CUTOFF_MIN, 0, 0); }
      var rem = nc - now; if (rem < 0) rem = 0;
      var h = Math.floor(rem / 36e5), m = Math.floor((rem % 36e5) / 6e4);
      if ($('hps-cutoff-time')) $('hps-cutoff-time').textContent = h > 0 ? h + 'h ' + m + 'm' : (m > 0 ? m + 'm' : 'soon');
    }
    tick();
    ticker = setInterval(tick, 60000);
  }

  function setLoc(txt) { if ($('hps-location')) $('hps-location').textContent = txt; }

  function applyZip(z) {
    lsSet('hps_zip', z);
    setLoc(z);
    if ($('hps-zip-input')) $('hps-zip-input').value = z;
    render(zoneFor(z));
  }

  function onGo() {
    var inp = $('hps-zip-input'); if (!inp) return;
    var v = (inp.value || '').replace(/\D/g, '').slice(0, 5);
    if ($('hps-error')) $('hps-error').textContent = '';
    if (/^\d{5}$/.test(v)) applyZip(v);
    else if ($('hps-error')) $('hps-error').textContent = 'Enter a 5-digit ZIP.';
  }

  function init() {
    var go = $('hps-zip-go'); if (go) go.addEventListener('click', onGo);
    var inp = $('hps-zip-input');
    if (inp) {
      inp.addEventListener('input', function () { this.value = this.value.replace(/\D/g, '').slice(0, 5); if ($('hps-error')) $('hps-error').textContent = ''; });
      inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); onGo(); } });
    }
    var saved = lsGet('hps_zip');
    if (/^\d{5}$/.test(saved)) applyZip(saved);
    else { setLoc('United States'); render(DEFAULT_WINDOW); }
    console.log('[delivery-strip] external script running');
  }

  var tries = 0;
  function boot() {
    if ($('hps-order-date')) { init(); return; }
    if (++tries < 67) setTimeout(boot, 150);
    else console.warn('[delivery-strip] markup not found on this page');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();